module.exports = __webpack_public_path__ + "static/img/language_en.fe7d4c67.png";